import React from "react";
import LogoLight2x from "../../images/logo2x.png";
import LogoDark2x from "../../images/logo-dark2x.png";

const Logo = () => {
  return (
    <div className="logo-link">
      <img className="logo-light logo-img" src={LogoLight2x} alt="logo" width={120} />
      <img className="logo-dark logo-img" src={LogoDark2x} alt="logo" width={120} />
    </div>
  );
};

export default Logo;
